import { render, staticRenderFns } from "./merchant.vue?vue&type=template&id=0f13d219&scoped=true&"
import script from "./merchant.vue?vue&type=script&lang=js&"
export * from "./merchant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f13d219",
  null
  
)

export default component.exports